// extracted by mini-css-extract-plugin
export default {"author":"wNGzt1Y8o9e6AtGO68ew"};